export default __webpack_public_path__ + "static/media/NotoSans-latin.6eb473d3.woff2";